<div class="text-xs opacity-50">
  {{ label() }}
  @if (tooltip(); as tooltip) {
    <mat-icon class="icon-xs" matTooltip="{{ tooltip }}">info</mat-icon>
  }
</div>
<div class="text-lg font-bold">
  <ng-content />
</div>
